
import Create from "views/adminViews/Create.js";
import UsersList from "views/adminViews/UsersList.js";
import User from "views/adminViews/User.js";
import Password from "views/adminViews/ChangePassword.js";
import TransactionList from "views/adminViews/TransactionList.js";
import Transaction from "views/adminViews/Transaction.js";
import CreateTransaction from "views/adminViews/CreateTransaction.js";
import ViewTransactionList from "views/adminViews/ViewTransactionList.js";
import Notification from "views/adminViews/Notification";
import Wallets from "views/adminViews/Wallets";
import Gift from "views/adminViews/Gift";
import Chat from "views/adminViews/Chat";


var adminRoutes = [
  {
    path: "/create",
    name: "Create user",
    icon: "nc-icon nc-chart-bar-32",
    component: <Create />,
    layout: "/admin",
  },
  {
    path: "/users",
    name: "view all user",
    icon: "nc-icon nc-tile-56",
    component: <UsersList />,
    layout: "/admin",
  },
  {
    path: "/transactions",
    name: "transactions",
    icon: "nc-icon nc-tile-56",
    component: <TransactionList />,
    layout: "/admin",
  },
  {
    path: "/wallets",
    name: "wallets",
    icon: "nc-icon nc-app",
    component: <Wallets />,
    layout: "/admin",
  },
   {
    path: "/gifts",
    name: "Gift cards",
    icon: "nc-icon nc-app",
    component: <Gift />,
    layout: "/admin",
  },
  {
    path: "/users/:id",
    name: "view 1",
    icon: "nc-icon nc-tile-56",
    component: <User />,
    layout: "/admin",
    hidden: true,
  },
  {
    path: "/users/password/:id",
    name: "view 2",
    icon: "nc-icon nc-tile-56",
    component: <Password />,
    layout: "/admin",
    hidden: true,
  },
  {
    path: "/transaction/:id",
    name: "view 3",
    icon: "nc-icon nc-chart-bar-32",
    component: <CreateTransaction />,
    layout: "/admin",
    hidden: true,
  },
  {
    path: "/transaction/:id/view",
    name: "view 4",
    icon: "nc-icon nc-tile-56",
    component: <ViewTransactionList />,
    layout: "/admin",
    hidden: true,
  },
  {
    path: "/transaction/:id/edit",
    name: "view 5",
    icon: "nc-icon nc-tile-56",
    component: <Transaction />,
    layout: "/admin",
    hidden: true,
  },
  {
    path: "/send-notification/:id",
    name: "view 6",
    icon: "nc-icon nc-tile-56",
    component: <Notification />,
    layout: "/admin",
    hidden: true,
  },
  {
    path: "/chat",
    name: "Support Chat",
    icon: "nc-icon nc-chat-33",
    component: <Chat />,
    layout: "/admin",
  },
  
  
];
export default adminRoutes;
